<div class="navbar-custom topnav-navbar topnav-navbar-ispra">
  <div class="container-fluid">
    <a href="https://mosaicositicontaminati.isprambiente.it" target="_blank" class="topnav-logo">
      <span class="topnav-logo-lg">
          <img src="assets/images/logo-light.png" alt="" height="50">
      </span>
      <span class="topnav-logo-sm">
          <img src="assets/images/logo_sm.png" alt="" height="50">
      </span>
    </a>
    <ul class="list-unstyled topbar-menu float-end mb-0">
      <li class="dropdown notification-list" style="line-height: 50px;">
        <a href="{{ config.applicationSettings.manualUser }}" class="guida btn btn-light fw-bold" data-bs-toggle="tooltip" data-bs-placement="top" title="Guida">
          <i class="dripicons-information me-1"></i><span class="d-none d-lg-inline-block">Guida</span>
        </a>
      </li>
      <li class="dropdown notification-list">
        <a class="nav-link dropdown-toggle nav-user arrow-none me-0" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
          <span class="account-user-avatar">
            <img *ngIf="!infoUserLogin.user.thumbnail" src="assets/images/users/no-user-thumb.jpg" alt="user-image" class="rounded-circle">
            <img *ngIf="infoUserLogin.user.thumbnail" src="{{infoUserLogin.user.thumbnail}}" alt="user-image" class="rounded-circle">
          </span>
          <span>
            <span class="account-user-name">{{infoUserLogin.user.username}}</span> <span class="account-position">{{infoUserLogin.user.roleDisplay}}</span>
          </span>
        </a>
        <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown">
          <a href="{{config.portalUrl}}home/user.html" target="_blank" class="dropdown-item notify-item"> <i class="mdi mdi-account-circle me-1"></i> <span>My Profile</span> </a>
          <a href="{{config.portalUrl}}home/user.html#settings" target="_blank" class="dropdown-item notify-item"> <i class="mdi mdi-account-edit me-1"></i> <span>Settings</span> </a>
          <a routerLink="logout" class="dropdown-item notify-item"> <i class="mdi mdi-logout me-1"></i> <span>Logout</span> </a>
        </div>
      </li>
    </ul>

    <div class="d-none d-lg-block">
      <h3 class="titleHeader">
        Banca Dati Nazionale per i Siti Contaminati | {{infoUserLogin.user.groupsMosaico}}
      </h3>
    </div>
  </div>
</div>
